import DateFnsUtils from '@date-io/date-fns';
import {
  Button, Card, CardContent,
  CardHeader,
  CircularProgress, Container,
  createTheme,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import React, { useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser, moneyFormat } from 'src/utils/Common';
import logger from 'src/utils/logger';



const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  container: {
    maxHeight: 440,
  },
}));

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    },
  },
});
const localeMap = {
  tr: trLocale,
};

function CariHesap() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const Uyari = "";
  const [, setResponseData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [, setBitisTarihi] = React.useState(today);
  const [CariDataTeminat, setCariDataTeminat] = React.useState(0.00);
  const [CariDataUstGroup, setCariDataUstGroup] = React.useState([]);
  const [CariDataTarih, setCariDataTarih] = React.useState([]);
  const [ToplamBorcTarih, setToplamBorcTarih] = React.useState([]);
  const [ToplamBorc, setToplamBorc] = React.useState([]);
  const [YsBorc, setYsBorc] = React.useState([]);
  const [YsAlacak, setYsAlacak] = React.useState([]);
  const [ToplamMalzemeBorcu, setToplamMalzemeBorcu] = React.useState([]);



  const groupBy = require('group-by-with-sum');






  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format("YYYY-MM-DD");
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };



  const handleSearch = () => {

    setLoading(true);
    axios.get('/GetCariHesap/M' + SessionUser.ServiceShopCode + "/" + SessionUser.OrganizationUserId + "/" + moment(baslangicTarihi).format("YYYY-MM-DD"))
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);

        } else {
          setResponseData(Data?.ArrayOfZFI_YS_WS_AK_LIST?.ZFI_YS_WS_AK_LIST);
          var CariData = Data?.ArrayOfZFI_YS_WS_AK_LIST?.ZFI_YS_WS_AK_LIST;
          var Tarih = moment(baslangicTarihi).format("YYYY-MM-DD");
          var CariDataTeminat1 = (CariData.filter(x => x.dOC_TYPEField === 'TM').reduce((a, v) => a = a + parseFloat(v.lC_AMOUNTField), 0));
          var CariDataUstGroup1 = CariData.filter(x => x.dOC_TYPEField !== 'TM');
          var CariDataUstGroupParam = groupBy(CariDataUstGroup1, 'dOC_TYPEField', 'lC_AMOUNTField');

          var CariDataTarih1 = CariData.filter(x => x.dOC_TYPEField !== 'TM' && moment(x.bLINE_DATEField) <= moment(Tarih));

          var CariDataTarihParam = groupBy(CariDataTarih1, 'dOC_TYPEField', 'lC_AMOUNTField');
          var ToplamBorcTarih1 = CariData.filter(x => x.dOC_TYPEField !== 'TM' && moment(x.bLINE_DATEField) <= moment(Tarih));
          var ToplamBorcTarihParam = ToplamBorcTarih1.reduce((a, v) => a = a + parseFloat(v.lC_AMOUNTField), 0);
          var ToplamBorc1 = CariData.filter(x => x.dOC_TYPEField !== 'TM');
          var ToplamBorcParam = ToplamBorc1.reduce((a, v) => a = a + parseFloat(v.lC_AMOUNTField), 0);
          var YsBorc1 = CariData.filter(x => x.dOC_TYPEField === 'RV' || x.dOC_TYPEField === 'DR' || x.dOC_TYPEField === 'KG');
          var YsBorcParam = YsBorc1.reduce((a, v) => a = a + parseFloat(v.lC_AMOUNTField), 0);

          var YsAlacak1 = CariData.filter(x => x.dOC_TYPEField === 'RZ' || x.dOC_TYPEField === 'DG' || x.dOC_TYPEField === 'KR' || x.dOC_TYPEField === 'AB' || x.dOC_TYPEField === 'SB');
          var YsAlacakParam = YsAlacak1.reduce((a, v) => a = a + parseFloat(v.lC_AMOUNTField), 0);
          
          var ToplamMalzemeBorcu1 = CariDataUstGroupParam.filter(x => x.dOC_TYPEField === 'RV' || x.dOC_TYPEField === 'RZ' || x.dOC_TYPEField === 'DR' || x.dOC_TYPEField === 'DG' || x.dOC_TYPEField === 'ZM');
          var ToplamMalzemeBorcuParam = ToplamMalzemeBorcu1.reduce((a, v) => a = a + parseFloat(v.lC_AMOUNTField), 0);

          setCariDataUstGroup(CariDataUstGroupParam);
          setCariDataTarih(CariDataTarihParam);
          setToplamBorcTarih(ToplamBorcTarihParam);
          setToplamBorc(ToplamBorcParam);
          setYsBorc(YsBorcParam);
          setYsAlacak(YsAlacakParam);
          setToplamMalzemeBorcu(ToplamMalzemeBorcuParam);
          setCariDataTeminat(CariDataTeminat1);


        }



        setLoading(false);
      }).catch(error => {
        setResponseData([]);
logger.error("Hata detayı:", error.message);
        setLoading(false);
      });
  }



  return (
    <Page className={classes.root} title="Cari Hesap">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="Cari Hesap" />
          <Divider />
          <CardContent>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      fullWidth
                      inputVariant="outlined"
                      label={'Başlangıç Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
          </CardContent>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align='right'>Teminat:</TableCell>
                  <TableCell align='right'> {moneyFormat(CariDataTeminat * -1, 'try', 'try')}₺</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='right'>Toplam Malzeme Borcu:</TableCell>
                  <TableCell align='right'> {moneyFormat(ToplamMalzemeBorcu, 'try', 'try')}₺</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='right'>Kalan Teminat:</TableCell>
                  <TableCell align='right'> {moneyFormat((CariDataTeminat * -1) - ToplamMalzemeBorcu, 'try', 'try')}₺</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          <br />
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align='center' colSpan={4}>Vadesi Gelmiş Borç ve Alacaklarınız</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='right'></TableCell>
                  <TableCell align='right'></TableCell>
                  <TableCell align='right'>YSBorç</TableCell>
                  <TableCell align='right'>YSAlacak</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {CariDataTarih.map(item => (
                  <TableRow key={item.dOC_TYPEField}>
                    <TableCell align='left'>{item.dOC_TYPEField}</TableCell>
                    <TableCell align='left'>{
                      item.dOC_TYPEField === "RV" ? "Malzeme Satış Faturası" :
                        item.dOC_TYPEField === "DR" ? "Servise Düzenlenen Faturası" :
                          item.dOC_TYPEField === "KG" ? "Fiş Paketi İade Faturası" :
                            item.dOC_TYPEField === "RZ" ? "Malzeme İade Faturası" :
                              item.dOC_TYPEField === "DG" ? "İskonto ve Diğer Alacak Faturaları" :
                                item.dOC_TYPEField === "KR" ? "Servisten Alınan Faturalar" :
                                  item.dOC_TYPEField === "SB" ? "Fiş Paketi Faturası" :
                                    item.dOC_TYPEField === "DA" ? "Taksit" :
                                      item.dOC_TYPEField === "SA" ? "Virman Belgesi" :
                                        item.dOC_TYPEField === "ZM" ? "Banka Kaydı" :
                                          item.dOC_TYPEField === "AB" ? "Denkleştirme Farkı" :
                                            ""
                    }</TableCell>

                    <TableCell align='right'>{moneyFormat(item.lC_AMOUNTField >= 0 ? item.lC_AMOUNTField : 0, 'try', 'try')}₺</TableCell>
                    <TableCell align='right'>{moneyFormat(item.lC_AMOUNTField < 0 ? item.lC_AMOUNTField : 0, 'try', 'try')}₺</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={2}><b>Toplam Vadesi Gelmiş Borç ve Alacaklarınız</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(ToplamBorcTarih >= 0 ? ToplamBorcTarih : 0, 'try', 'try')}₺</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(ToplamBorcTarih < 0 ? ToplamBorcTarih : 0, 'try', 'try')}₺</b></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align='center' colSpan={4}>Toplam Borç ve Alacaklarınız</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='right' colSpan={2}></TableCell>
                  <TableCell align='right'>YSBorç</TableCell>
                  <TableCell align='right'>YSAlacak</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {CariDataUstGroup.map(item => (
                  <TableRow key={item.dOC_TYPEField}>
                    <TableCell>{item.dOC_TYPEField}</TableCell>
                    <TableCell>{
                      item.dOC_TYPEField === "RV" ? "Malzeme Satış Faturası" :
                        item.dOC_TYPEField === "DR" ? "Servise Düzenlenen Faturası" :
                          item.dOC_TYPEField === "KG" ? "Fiş Paketi İade Faturası" :
                            item.dOC_TYPEField === "RZ" ? "Malzeme İade Faturası" :
                              item.dOC_TYPEField === "DG" ? "İskonto ve Diğer Alacak Faturaları" :
                                item.dOC_TYPEField === "KR" ? "Servisten Alınan Faturalar" :
                                  item.dOC_TYPEField === "SB" ? "Fiş Paketi Faturası" :
                                    item.dOC_TYPEField === "DA" ? "Taksit" :
                                      item.dOC_TYPEField === "SA" ? "Virman Belgesi" :
                                        item.dOC_TYPEField === "ZM" ? "Banka Kaydı" :
                                          item.dOC_TYPEField === "AB" ? "Denkleştirme Farkı" :
                                            ""
                    }</TableCell>
                    <TableCell align='right'>{moneyFormat(item.lC_AMOUNTField >= 0 ? item.lC_AMOUNTField : 0, 'try', 'try')}₺</TableCell>
                    <TableCell align='right'>{moneyFormat(item.lC_AMOUNTField < 0 ? item.lC_AMOUNTField : 0, 'try', 'try')}₺</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={2}><b>Toplam</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(YsBorc, 'try', 'try')}₺</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(YsAlacak, 'try', 'try')}₺</b></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2}><b>Net Borç/Alacak</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(ToplamBorc >= 0 ? ToplamBorc : 0, 'try', 'try')}₺</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(ToplamBorc < 0 ? ToplamBorc : 0, 'try', 'try')}₺</b></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3}><b>Teminat Tutarı</b></TableCell>
                  <TableCell align='right'><b>{moneyFormat(CariDataTeminat * -1, 'try', 'try')}₺</b></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default CariHesap;
